import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div
        data-testid="protected-loading"
        className="min-h-screen grid place-items-center bg-[var(--bb-cream)]"
      >
        <Loader2 className="w-8 h-8 animate-spin text-[var(--bb-red)]" strokeWidth={2.5} />
      </div>
    );
  }
  if (!user) return <Navigate to="/employee" replace />;
  return children;
}
